import { render } from "./TimeSlotsSelectionRedirect.vue?vue&type=template&id=421d1f51&scoped=true"
import script from "./TimeSlotsSelectionRedirect.vue?vue&type=script&lang=js"
export * from "./TimeSlotsSelectionRedirect.vue?vue&type=script&lang=js"

import "./TimeSlotsSelectionRedirect.vue?vue&type=style&index=0&id=421d1f51&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-421d1f51"

export default script